import { Grid, MenuItem, Switch, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useDisplayGlobalContext } from '../../../context/contexts';

const StyledMenuItem = styled(MenuItem)`
  padding: 5px 10px;
` as typeof MenuItem;

const ToggleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DisplaySettingsMenu = () => {
  const { t } = useTranslation();
  const displayHandle = useDisplayGlobalContext();
  const [displayState, displayDispatch] = displayHandle;

  return (
    <Grid direction={'column'} container>
      <Tooltip title={t('common:buttonsAndMenus.label')}>
        <StyledMenuItem>
          <ToggleContainer>
            {' '}
            <Typography variant="body2">
              {t('common:buttonsAndMenus.label')}
            </Typography>
            <Switch
              color="primary"
              disabled={!displayState.enableLabels}
              checked={displayState.showLabels}
              onClick={() => displayDispatch({ type: 'toggle-labels' })}
            />{' '}
          </ToggleContainer>
        </StyledMenuItem>
      </Tooltip>
      <Tooltip title={t('common:buttonsAndMenus.legend')}>
        <StyledMenuItem>
          <ToggleContainer>
            {' '}
            <Typography variant="body2">
              {t('common:buttonsAndMenus.legend')}
            </Typography>
            <Switch
              color="primary"
              disabled={displayState.enableLegend === false}
              checked={displayState.showLegend}
              onClick={() => displayDispatch({ type: 'toggle-legend' })}
            />{' '}
          </ToggleContainer>
        </StyledMenuItem>
      </Tooltip>
      <Tooltip title={t('common:buttonsAndMenus.percentage')}>
        <StyledMenuItem>
          <ToggleContainer>
            {' '}
            <Typography variant="body2">
              {t('common:buttonsAndMenus.percentage')}
            </Typography>
            <Switch
              color="primary"
              disabled={!displayState.enablePercentage}
              checked={displayState.showPercentage}
              onClick={() => displayDispatch({ type: 'toggle-percentage' })}
            />{' '}
          </ToggleContainer>
        </StyledMenuItem>
      </Tooltip>
      <Tooltip title={t('common:buttonsAndMenus.stack')}>
        <StyledMenuItem>
          <ToggleContainer>
            {' '}
            <Typography variant="body2">
              {t('common:buttonsAndMenus.stack')}
            </Typography>
            <Switch
              color="primary"
              disabled={!displayState.enableStack}
              checked={displayState.showStack}
              onClick={() => displayDispatch({ type: 'toggle-stack' })}
            />{' '}
          </ToggleContainer>
        </StyledMenuItem>
      </Tooltip>
      <Tooltip title={t('common:buttonsAndMenus.toggleGridlines')}>
        <StyledMenuItem>
          <ToggleContainer>
            {' '}
            <Typography variant="body2">
              {t('common:buttonsAndMenus.toggleGridlines')}
            </Typography>
            <Switch
              color="primary"
              disabled={!displayState.enableGridLines}
              checked={displayState.showGridLines}
              onClick={() => displayDispatch({ type: 'toggle-gridlines' })}
            />{' '}
          </ToggleContainer>
        </StyledMenuItem>
      </Tooltip>
    </Grid>
  );
};
